import * as React from 'react';
import { Table } from 'antd';
import strings from '../../eyeguide-localization/user/string.user';
import { CustomSorter } from '../Sorter';

interface IShareListProp {
    users: any;
    notifyActiveClick: any;
}

/**
 * State definition
 */
interface IShareListState {
    columnData: Array<any>;
    columns: Array<any>;
    pagination: any;
    loading: boolean;
}

export default class ExternalUserList extends React.Component<IShareListProp, IShareListState> {

    constructor(props: IShareListProp) {
        super(props);
        this.state = {
            columnData: this.buildData(this.props.users),
            columns: this.buildColumns(),
            pagination: {},
            loading: false
        };
    }

    componentWillReceiveProps(nextProps: any) {
        console.log('componentDidMount', nextProps.users);
        const pagination = { ...this.state.pagination };
        pagination.total = nextProps.users.length;
        pagination.pageSize = 20 ;
        pagination.pageSizeOptions = ['20', '50', '75', '100'];
        pagination.showSizeChanger = true ;  
        pagination.showTotal = function (total: any) {
            return strings.formatString(strings.lsTotalSharees, total);
        };
        this.setState({
            columnData: this.buildData(nextProps.users),
            columns: this.buildColumns(),
            pagination: pagination,
            loading: false
        });
    }

    render() {
        return(
            // <div>External User List</div>
            <Table
                columns={this.state.columns}
                dataSource={this.state.columnData}
                loading={this.state.loading}
                pagination={this.state.pagination}
            />
        );
    }

    private buildData(users: Array<any>) {
        let columnData: Array<any> = [];
        users.forEach( (element: any) => {
            console.log('build', element );
            let data = {
                id              : element.id,
                firstname       : element.firstname,
                lastname        : element.lastname,
                email           : element.email,
                viewStatus      : element.viewstatus === 0 ? 
                            strings.lsNotViewed : strings.lsViewed,
                active          : element.active,
                shareid        : element.shareid
            };
            columnData.push(data);
        }); 
        console.log('columnData', columnData);
        return columnData;
    }

    private buildColumns() {
        let columns = [
            {
                title: strings.lsFNameTxt,
                dataIndex: 'firstname',
                sorter: (a: any, b: any) => a.firstname.localeCompare(b.firstname),
                className: 'rows',
                onHeaderCell: (column) => {
                    return {
                        onClick: () => {
                            this.setState({
                                columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                            });
                        }
                    };
                }
            },
            {
                title: strings.lsLNameTxt,
                dataIndex: 'lastname',
                sorter: (a: any, b: any) => a.lastname.localeCompare(b.lastname),
                className: 'rows',
                onHeaderCell: (column) => {
                    return {
                        onClick: () => {
                            this.setState({
                                columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                            });
                        }
                    };
                }
            },    
            {
                title: strings.lsEmailTxt,
                dataIndex: 'email',
                sorter: (a: any, b: any) => a.email.localeCompare(b.email),
                className: 'rows',
                onHeaderCell: (column) => {
                    return {
                        onClick: () => {
                            this.setState({
                                columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                            });
                        }
                    };
                }
            },  
            {
                title: strings.lsViewStatus,
                dataIndex: 'viewStatus',
                sorter: (a: any, b: any) => a.email.localeCompare(b.viewStatus),
                className: 'rows',
                onHeaderCell: (column) => {
                    return {
                        onClick: () => {
                            this.setState({
                                columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                            });
                        }
                    };
                }
            },
            {
                title: strings.lsActionTxt,
                dataIndex: 'testid',
                className: 'rows',
                render: (text: any, record: any) => (
                    <a 
                        onClick={ (e) => {    
                            console.log('record in onclick', record);  
                            console.log('e', e);
                            console.log('text', text);
                            e.stopPropagation();               
                            this.props.notifyActiveClick(record.active === 0 ? 1 : 0, 
                                                         record.shareid, record.id, record); }
                        }
                    >{record.active === 0 ? strings.lsActivateTxt : strings.lsDeActivateTxt}
                    </a>
                )
            }

        ];
        return columns;
    }

}


// WEBPACK FOOTER //
// ./src/components/user/ExternalUserList.tsx